export const ADD_FORM = "ADD_FORM";
export const INCREASE_COUNTER = "INCREASE_COUNTER";
export const DECREASE_COUNTER = "DECREASE_COUNTER";
export const SAVE_COUNTERS = "SAVE_COUNTERS";
export const RESTORE_COUNTERS = "RESTORE_COUNTERS";
export const UPDATE_COUNTER = "UPDATE_COUNTER";

// for localStorage:
export const STORAGE_KEY = "counters-vuejs";
